import {
  Box,
  Button,
  Center,
  HStack,
  Icon,
  Image,
  Link,
  Stack,
  Text
} from "@chakra-ui/react";

import { TbBuildingBank, TbHistory, TbWallet } from "react-icons/tb";

import { IBank } from "@/jenesys-types/jenesys-entities/config";

interface Props {
  bank: IBank;
  confirmBankDetails: () => void;
  isLoading: boolean;
}

export const ReviewBankDetails = ({
  bank,
  confirmBankDetails,
  isLoading
}: Props) => {
  const { name, raw } = bank;

  return (
    <Box>
      <Text fontWeight={700}>Review Details</Text>
      <Text mt={2} fontSize={14}>
        We have partnered with <b>Yapily Connect Ltd</b> to access your bank
        data at
        <b> {name}</b>. When we share this information with you, we are acting
        as a Third Party Provider of Authorised Account Information Service
        (AIS) provided by <b>Yapily Connect Ltd</b>.
      </Text>

      <HStack mt={8} spacing={3}>
        <Image boxSize={7} src={raw.media[0]?.source} alt={name} />

        <Text fontSize={14} fontWeight={600}>
          You will now be securely redirected to {name} to give access to the
          following information:
        </Text>
      </HStack>

      <Stack mt={4} spacing={2}>
        <HStack>
          <Center boxSize={7} rounded={3} bg="blackAlpha.50">
            <Icon fontSize={20} as={TbBuildingBank} color="secondary.500" />
          </Center>
          <Text fontSize={14}>Your Bank Account(s) details</Text>
        </HStack>

        <HStack>
          <Center boxSize={7} rounded={3} bg="blackAlpha.50">
            <Icon fontSize={20} as={TbWallet} color="secondary.500" />
          </Center>
          <Text fontSize={14}>Your Account(s) Balance Information</Text>
        </HStack>

        <HStack>
          <Center boxSize={7} rounded={3} bg="blackAlpha.50">
            <Icon fontSize={20} as={TbHistory} color="secondary.500" />
          </Center>
          <Text fontSize={14}>Your Transaction history</Text>
        </HStack>
      </Stack>

      <Text mt={6} fontSize={14}>
        By clicking &quot;Accept and Connect&quot;, you agree to
        <b> Yapily Connect Ltd</b> accessing your bank data and its&nbsp;
        <Link
          href="https://www.yapily.com/legal/end-user-terms"
          target="_blank"
          fontWeight="bold"
        >
          <u>Terms & Conditions</u>
        </Link>
        &nbsp;and&nbsp;
        <Link
          href="https://www.yapily.com/legal/privacy-policy"
          target="_blank"
          fontWeight="bold"
        >
          <u>Privacy Notice</u>
        </Link>
        .
      </Text>

      <Button
        isLoading={isLoading}
        loadingText="Connecting..."
        onClick={confirmBankDetails}
        mt={4}
        h={9}
        size="sm"
        w="full"
      >
        Accept & Connect
      </Button>
    </Box>
  );
};
